import { formatDate } from '@vueuse/core'

export const fromDateString = (val: string) => {
  const parts = val
    .split('-', 3)
    .map((x, i) => parseInt(x) - (i === 1 ? 1 : 0)) as [number, number, number]
  return new Date(...parts, 0, 0)
}

export const toDateString = (
  date: Date,
  fmt: string = 'YYYY-MM-DD',
  lang: string = 'en',
) => {
  date.setHours(0, 0)
  return formatDate(date, fmt, { locales: [lang] })
}

export const isDateString = (val: string): boolean => !isNaN(Date.parse(val))
